<main>
  <ng-container *ngIf="!isOverviewer">
    <article
      class="viewBursariesMainContainer"
      [ngClass]="{
        'admin': applyAdminTabStyle()
      }"
    >
      <h1 *ngIf="isDean" class="department-header">
        Department of {{ department }}
      </h1>
      <section class="viewBursariesContainer">
        <app-allocation-usage> </app-allocation-usage>
      </section>
      <mat-divider class="divider"></mat-divider>

      <section
        class="dashboard"
        fxLayout="row"
        fxLayout.xs="column"
        fxLayoutAlign="start start"
        fxLayoutGap="20px"
      >
        <form class="search-container" [formGroup]="filterForm">
          <mat-form-field
            class="search-box"
            appearance="outline"
            subscriptSizing="dynamic"
            >
            <mat-label>Filter by year</mat-label>
            <mat-select
              [(value)]="hodFiscalYear"
              (selectionChange)="filterActiveApplicationsByDate($event)"
              formControlName="filterYear"
            >
              <mat-option *ngFor="let date of hodDateOptions" [value]="date">{{
                date
              }}</mat-option>
            </mat-select>
          </mat-form-field>
        </form>
        <mat-tab-group
          mat-stretch-tabs="false"
          mat-align-tabs="start"
          animationDuration="0ms"
          [(selectedIndex)]="selectedTabIndex"
          (selectedTabChange)="tabChanged($event)"
        >
          <mat-tab
            label="Active Bursaries ({{
              numberOfActiveBursaries ? numberOfActiveBursaries : '0'
            }})"
            class="label custom-tab-label"
            [class.active]="isActive"
          >
            <section class="tab-details">
             <section *ngFor="let application of getPaginatedData(activeBursaries); let index = index">

               <app-application-details
                 [application]="application"
                 [currentTab]="'approved'"
                 [index]="index"
                 [applicationArrayLength]="activeBursaries.length"
               ></app-application-details>

             </section>
             <mat-paginator
               *ngIf="activeBursaries.length > 0"
               [pageSizeOptions]="pageSizeOptions"
               [length]="activeBursaries.length"
               [pageIndex]="pageIndex"
               [pageSize]="displayPageSize"
               (page)="onPageChange($event)">
             </mat-paginator>
              <section class="error-text-container">
                <p *ngIf="numberOfActiveBursaries === 0 && !isLoading" class="error-text">
                  No applications found
                </p>
              </section>
            </section>
          </mat-tab>
          <section>
            <mat-tab
              label="Applications ({{
                numberOfApplications ? numberOfApplications : '0'
              }})"
              class="label custom-tab-label"
              [class.active]="selectedTab === 'Review'"
            >
              <article class="tab-container">
                <ul class="tab-list">
                  <li
                    class="tabs"
                    [class.active]="selectedTab === 'In review'"
                    (click)="setSelectedTab('In review')"
                  >
                    In review <span>({{ numberInReviewApplications }})</span>
                  </li>
                  <li
                    class="tabs"
                    [class.active]="selectedTab === 'Invoice'"
                    (click)="setSelectedTab('Invoice')"
                  >
                    Invoice <span>({{ numberInvoiceApplications }})</span>
                  </li>
                  <li
                    class="tabs"
                    [class.active]="selectedTab === 'Payment'"
                    (click)="setSelectedTab('Payment')"
                  >
                    Awaiting Payment
                    <span>({{ numberPaymentApplications }})</span>
                  </li>

                  <li
                    class="tabs"
                    [class.active]="selectedTab === 'Declined'"
                    (click)="setSelectedTab('Declined')"
                  >
                    Declined <span>({{ numberDeclinedApplications }})</span>
                  </li>
                </ul>
              </article>
              <mat-card class="details-card">
                <mat-card-content>
                  <p class="description" *ngIf="selectedTab">
                    {{ getTabDescription() }}
                  </p>
                  <article class="tab-content">
                    <section
                      *ngIf="
                        selectedTab === 'In review' &&
                          filteredInReview.length > 0;
                        else noReview
                      "
                    >
                      <section
                        *ngFor="
                          let application of getPaginatedData(filteredInReview);
                          let i = index
                        "
                      >
                        <app-application-details
                          [application]="application"
                          [currentTab]="selectedTab"
                          [index]="i"
                          [applicationArrayLength]="filteredInReview.length"
                        ></app-application-details>
                      </section>
                      <mat-paginator
                        [pageSizeOptions]="pageSizeOptions"
                        [length]="filteredInReview.length"
                        [pageIndex]="pageIndex"
                        [pageSize]="displayPageSize"
                        (page)="onPageChange($event)">
                      </mat-paginator>
                    </section>
                    <section
                      *ngIf="
                        selectedTab === 'Declined' &&
                          filteredDeclined.length > 0;
                        else noDeclined
                      "
                    >
                      <section
                        *ngFor="
                          let application of getPaginatedData(filteredDeclined);
                          let i = index;
                          let last = last
                        "
                      >
                        <app-application-details
                          [application]="application"
                          [currentTab]="selectedTab"
                          [index]="i"
                          [applicationArrayLength]="filteredDeclined.length"
                        ></app-application-details>
                      </section>
                      <mat-paginator
                        [pageSizeOptions]="pageSizeOptions"
                        [length]="filteredDeclined.length"
                        [pageIndex]="pageIndex"
                        [pageSize]="displayPageSize"
                        (page)="onPageChange($event)">
                      </mat-paginator>
                    </section>
                    <section
                      *ngIf="
                        selectedTab === 'Invoice' &&
                          numberInvoiceApplications > 0;
                        else noInvoice
                      "
                    >
                      <section
                        *ngFor="
                          let application of getPaginatedData(filteredInvoice);
                          let i = index;
                          let last = last
                        "
                      >
                        <app-application-details
                          [application]="application"
                          [currentTab]="selectedTab"
                          [index]="i"
                          [applicationArrayLength]="filteredInvoice.length"
                        ></app-application-details>
                      </section>
                      <mat-paginator
                        [pageSizeOptions]="pageSizeOptions"
                        [length]="filteredInvoice.length"
                        [pageIndex]="pageIndex"
                        [pageSize]="displayPageSize"
                        (page)="onPageChange($event)">
                      </mat-paginator>
                    </section>
                    <ng-template #noInvoice>
                      <section
                        *ngIf="selectedTab === 'Invoice'"
                        class="error-text-container"
                      >
                        <p class="error-text">
                          You don't have any invoice applications
                        </p>
                      </section>
                    </ng-template>

                    <ng-template #noDeclined>
                      <section
                        *ngIf="selectedTab === 'Declined'"
                        class="error-text-container"
                      >
                        <p class="error-text">No applications found</p>
                      </section>
                    </ng-template>

                    <ng-template #noReview>
                      <section
                        *ngIf="selectedTab === 'In review'"
                        class="error-text-container"
                      >
                        <p class="error-text">
                          {{ noApplicationsErrorMessage }}
                        </p>
                      </section>
                    </ng-template>

                    <ng-template #noPayment>
                      <section
                        *ngIf="selectedTab === 'Payment'"
                        class="error-text-container"
                      >
                        <p class="error-text">
                          {{ noApplicationsErrorMessage }}
                        </p>
                      </section>
                    </ng-template>
                  </article>
                </mat-card-content>
              </mat-card>
              <section class="error-text-container"></section>
            </mat-tab>
          </section>
        </mat-tab-group>
      </section>
    </article>
    <app-loader></app-loader>
  </ng-container>

  <ng-container *ngIf="isOverviewer && !consolidatedView">
    <article class="viewBursariesMainContainer admin-view">
      <section class="top-section">
        <h1 class="top-name-section" (click)="goBack()">
          <mat-icon class="back-icon">chevron_left</mat-icon>
          {{ getUniversityName() }}
        </h1>
        <mat-form-field
          class="search-box"
          appearance="outline"
          subscriptSizing="dynamic"
        >
          <mat-label>Filter by year</mat-label>
          <mat-select
            [(ngModel)]="selectedDate"
            (selectionChange)="filterActiveApplicationsByDate($event)"
          >
            <mat-option *ngFor="let date of dateOptions" [value]="date">{{
              date
            }}</mat-option>
          </mat-select>
        </mat-form-field>
      </section>
      <section class="viewBursariesContainer">
        <app-allocation-usage> </app-allocation-usage>
      </section>
      <mat-divider class="divider"></mat-divider>
      <section
        class="dashboard"
        fxLayout="row"
        fxLayout.xs="column"
        fxLayoutAlign="start start"
        fxLayoutGap="20px"
      >
        <section class="search-container">
          <mat-form-field
            class="search-box"
            appearance="outline"
            subscriptSizing="dynamic"
          >
            <mat-icon matSuffix>search</mat-icon>
            <mat-label for="name">Search</mat-label>
            <input
              #searchInput
              [value]="getCurrentSearch()"
              (input)="onSearchInput({searchTerm: searchInput.value, searchType: 'name'})"
              matInput
              type="text"
            />
          </mat-form-field>
        </section>
        <mat-tab-group
          mat-stretch-tabs="false"
          mat-align-tabs="start"
          animationDuration="0ms"
          [(selectedIndex)]="selectedTabIndex"
          (selectedTabChange)="tabChanged($event)"
        >
          <mat-tab
            label="Active Bursaries ({{
              numberOfActiveBursaries ? numberOfActiveBursaries : '0'
            }})"
            class="label custom-tab-label"
            [class.active]="isActive"
          >
            <section class="tab-details">
              <section *ngFor="let application of getPaginatedData(activeBursaries); let index = index">

               <app-application-details
                 [application]="application"
                           [currentTab]="'approved'"
                           [index]="index"
                           [applicationArrayLength]="activeBursaries.length"
               ></app-application-details>

             </section>
             <mat-paginator
               *ngIf="activeBursaries.length > 0"
               [pageSizeOptions]="pageSizeOptions"
               [length]="activeBursaries.length"
               [pageIndex]="pageIndex"
               [pageSize]="displayPageSize"
               (page)="onPageChange($event)">
             </mat-paginator>
              <section class="error-text-container">
                <p *ngIf="numberOfActiveBursaries === 0 && !isLoading" class="error-text">
                  No applications found
                </p>
              </section>
            </section>
          </mat-tab>
          <mat-tab
            label="Applications ({{
              numberOfApplications ? numberOfApplications : '0'
            }})"
            class="label custom-tab-label"
            [class.active]="selectedTab === 'Review'"
          >
            <article class="tab-container">
              <ul class="tab-list">
                <li
                  class="tabs"
                  *ngIf="showAllTabs()"
                  [class.active]="selectedTab === 'Draft'"
                  (click)="setSelectedTab('Draft')"
                >
                  Draft <span>({{ numberDraftApplications }})</span>
                </li>
                <li
                  class="tabs"
                  *ngIf="showAllTabs()"
                  [class.active]="selectedTab === 'Email Failed'"
                  (click)="setSelectedTab('Email Failed')"
                >
                  Email failed
                  <span>({{ numberEmailFailedApplications }})</span>
                </li>
                <li
                  class="tabs"
                  [ngClass]="{ 'exec-tabs': !showAllTabs() }"
                  [class.active]="selectedTab === 'In review'"
                  (click)="setSelectedTab('In review')"
                >
                  In Review
                  <span>({{ numberInReviewApplications }})</span>
                </li>

                <li
                  class="tabs"
                  *ngIf="showAllTabs()"
                  [class.active]="selectedTab === 'Contract'"
                  (click)="setSelectedTab('Contract')"
                >
                  Contract<span>({{ numberContractApplications }})</span>
                </li>
                <li
                  class="tabs"
                  [ngClass]="{ 'exec-tabs': !showAllTabs() }"
                  [class.active]="selectedTab === 'Invoice'"
                  (click)="setSelectedTab('Invoice')"
                >
                    Invoice
                  <span>({{ numberInvoiceApplications }})</span>
                </li>
                <li
                  class="tabs"
                  *ngIf="showAllTabs()"
                  [class.active]="selectedTab === 'Payment'"
                  (click)="setSelectedTab('Payment')"
                >
                  Payment <span>({{ numberPaymentApplications }})</span>
                </li>
              </ul>
            </article>
            <mat-card class="details-card">
              <mat-card-content>
                <p class="description" *ngIf="selectedTab">
                  {{ getTabDescription() }}
                </p>
                <article class="tab-content">
                  <section
                    *ngIf="
                      selectedTab === 'Draft' && filteredDraft.length > 0;
                      else noDraft
                    "
                  >
                    <section
                      *ngFor="let application of getPaginatedData(filteredDraft); let i = index"
                    >
                      <app-application-details
                        [application]="application"
                        [currentTab]="selectedTab"
                        [index]="i"
                        [applicationArrayLength]="filteredDraft.length"
                      ></app-application-details>
                    </section>
                    <mat-paginator
                      [pageSizeOptions]="pageSizeOptions"
                      [length]="filteredDraft.length"
                      [pageIndex]="pageIndex"
                      [pageSize]="displayPageSize"
                      (page)="onPageChange($event)">
                    </mat-paginator>
                  </section>
                  <section
                    *ngIf="
                      selectedTab === 'In review' &&
                        filteredInReview.length > 0;
                      else noReview
                    "
                  >
                    <section
                      *ngFor="
                        let application of getPaginatedData(filteredInReview);
                        let i = index
                      "
                    >
                      <app-application-details
                        [application]="application"
                        [currentTab]="selectedTab"
                        [index]="i"
                        [applicationArrayLength]="filteredInReview.length"
                        (triggerStateReload)="triggerStateRefresh($event)"
                      ></app-application-details>
                    </section>
                    <mat-paginator
                      [pageSizeOptions]="pageSizeOptions"
                      [length]="filteredInReview.length"
                      [pageIndex]="pageIndex"
                      [pageSize]="displayPageSize"
                      (page)="onPageChange($event)">
                    </mat-paginator>
                  </section>
                  <section
                    *ngIf="
                      selectedTab === 'Email Failed' &&
                        filteredEmailFailed.length > 0;
                      else noEmailFailed
                    "
                  >
                    <section
                      *ngFor="
                        let application of getPaginatedData(filteredEmailFailed);
                        let i = index
                      "
                    >
                      <app-application-details
                        [application]="application"
                        [currentTab]="selectedTab"
                        [index]="i"
                        [applicationArrayLength]="filteredEmailFailed.length"
                      ></app-application-details>
                    </section>
                    <mat-paginator
                      [pageSizeOptions]="pageSizeOptions"
                      [length]="filteredEmailFailed.length"
                      [pageIndex]="pageIndex"
                      [pageSize]="displayPageSize"
                      (page)="onPageChange($event)">
                    </mat-paginator>
                  </section>
                  <section
                    *ngIf="
                      selectedTab === 'Contract' && filteredContract.length > 0;
                      else noContract
                    "
                  >
                    <section
                      *ngFor="
                        let application of getPaginatedData(filteredContract);
                        let i = index
                      "
                    >
                      <app-application-details
                        [application]="application"
                        [currentTab]="selectedTab"
                        [index]="i"
                        [applicationArrayLength]="filteredContract.length"
                        (triggerStateReload)="triggerStateRefresh($event)"
                      ></app-application-details>
                    </section>
                    <mat-paginator
                      [pageSizeOptions]="pageSizeOptions"
                      [length]="filteredContract.length"
                      [pageIndex]="pageIndex"
                      [pageSize]="displayPageSize"
                      (page)="onPageChange($event)">
                    </mat-paginator>
                  </section>
                  <section
                    *ngIf="
                      selectedTab === 'Pending' && filteredPending.length > 0;
                      else noPending
                    "
                  >
                    <section
                      *ngFor="let application of getPaginatedData(filteredPending); let i = index"
                    >
                      <app-application-details
                        [application]="application"
                        [currentTab]="selectedTab"
                        [index]="i"
                        [applicationArrayLength]="filteredPending.length"
                      ></app-application-details>
                    </section>
                    <mat-paginator
                      [pageSizeOptions]="pageSizeOptions"
                      [length]="filteredPending.length"
                      [pageIndex]="pageIndex"
                      [pageSize]="displayPageSize"
                      (page)="onPageChange($event)">
                    </mat-paginator>
                  </section>
                  <section
                    *ngIf="
                      selectedTab === 'Payment' && filteredPayment.length > 0;
                      else noPayment
                    "
                  >
                    <section
                      *ngFor="let application of getPaginatedData(filteredPayment); let i = index"
                    >
                      <app-application-details
                        [application]="application"
                        [currentTab]="selectedTab"
                        [index]="i"
                        [applicationArrayLength]="filteredPayment.length"
                        (triggerStateReload)="triggerStateRefresh($event)"
                      ></app-application-details>
                    </section>
                    <mat-paginator
                      [pageSizeOptions]="pageSizeOptions"
                      [length]="filteredPayment.length"
                      [pageIndex]="pageIndex"
                      [pageSize]="displayPageSize"
                      (page)="onPageChange($event)">
                    </mat-paginator>
                  </section>
                  <section
                    *ngIf="
                      selectedTab === 'Declined' && filteredDeclined.length > 0;
                      else noDeclined
                    "
                  >
                    <section
                      *ngFor="
                        let application of getPaginatedData(filteredDeclined);
                        let i = index;
                        let last = last
                      "
                    >
                      <app-application-details
                        [application]="application"
                        [currentTab]="selectedTab"
                        [index]="i"
                        [applicationArrayLength]="filteredDeclined.length"
                      ></app-application-details>
                    </section>
                    <mat-paginator
                      [pageSizeOptions]="pageSizeOptions"
                      [length]="filteredDeclined.length"
                      [pageIndex]="pageIndex"
                      [pageSize]="displayPageSize"
                      (page)="onPageChange($event)">
                    </mat-paginator>
                  </section>
                  <section
                    *ngIf="
                      selectedTab === 'Invoice' &&
                        numberInvoiceApplications > 0;
                      else noInvoice
                    "
                  >
                    <section
                      *ngFor="
                        let application of getPaginatedData(filteredInvoice);
                        let i = index;
                        let last = last
                      "
                    >
                      <app-application-details
                        *ngIf="application.documentsId !== -1"
                        [application]="application"
                        [currentTab]="selectedTab"
                        [index]="i"
                        [applicationArrayLength]="filteredInvoice.length"
                        (triggerStateReload)="triggerStateRefresh($event)"
                      ></app-application-details>
                    </section>
                    <mat-paginator
                      [pageSizeOptions]="pageSizeOptions"
                      [length]="filteredInvoice.length"
                      [pageIndex]="pageIndex"
                      [pageSize]="displayPageSize"
                      (page)="onPageChange($event)">
                    </mat-paginator>
                  </section>
                  <ng-template #noInvoice>
                    <section
                      *ngIf="selectedTab === 'Invoice'"
                      class="error-text-container"
                    >
                      <p class="error-text">
                        {{ noApplicationsErrorMessage }}
                      </p>
                    </section>
                  </ng-template>

                  <ng-template #noPending>
                    <section
                      *ngIf="selectedTab === 'Pending'"
                      class="error-text-container"
                    >
                      <p class="error-text">{{ noApplicationsErrorMessage }}</p>
                    </section>
                  </ng-template>
                  <ng-template #noEmailFailed>
                    <section
                      *ngIf="selectedTab === 'Email Failed'"
                      class="error-text-container"
                    >
                      <p class="error-text">{{ noApplicationsErrorMessage }}</p>
                    </section>
                  </ng-template>
                  <ng-template #noContract>
                    <section
                      *ngIf="selectedTab === 'Contract'"
                      class="error-text-container"
                    >
                      <p class="error-text">{{ noApplicationsErrorMessage }}</p>
                    </section>
                  </ng-template>
                  <ng-template #noDeclined>
                    <section
                      *ngIf="selectedTab === 'Declined'"
                      class="error-text-container"
                    >
                      <p class="error-text">{{ noApplicationsErrorMessage }}</p>
                    </section>
                  </ng-template>

                  <ng-template #noReview>
                    <section
                      *ngIf="selectedTab === 'In review'"
                      class="error-text-container"
                    >
                      <p class="error-text">{{ noApplicationsErrorMessage }}</p>
                    </section>
                  </ng-template>

                  <ng-template #noPayment>
                    <section
                      *ngIf="selectedTab === 'Payment'"
                      class="error-text-container"
                    >
                      <p class="error-text">{{ noApplicationsErrorMessage }}</p>
                    </section>
                  </ng-template>

                  <ng-template #noDraft>
                    <section
                      *ngIf="selectedTab === 'Draft'"
                      class="error-text-container"
                    >
                      <p class="error-text">{{ noApplicationsErrorMessage }}</p>
                    </section>
                  </ng-template>
                </article>
              </mat-card-content>
            </mat-card>
            <section class="error-text-container"></section>
          </mat-tab>
        </mat-tab-group>
      </section>
    </article>
  </ng-container>

  <ng-container *ngIf="isOverviewer  && consolidatedView">
    <article class="viewBursariesMainContainer admin-view" *ngIf="!isLoading">
      <h1 class="department-header page-header">{{ applicationsRoute ? 'Applications' : 'Active Bursaries'}}</h1>
      <section class="top-section filters-section">
        <mat-form-field
          class="search-box"
          appearance="outline"
          subscriptSizing="dynamic"
          floatLabel="always">
          <mat-icon matSuffix>search</mat-icon>
          <mat-label>Search</mat-label>
          <input
            #searchInput
            [value]="getCurrentSearch()"
            (input)="onSearchInput({searchTerm: searchInput.value, searchType: 'name'})"
            matInput
            type="text"
            placeholder="Search"/>
        </mat-form-field>
        <section class="filters-section">
          <mat-form-field
            class="search-box"
            appearance="outline"
            subscriptSizing="dynamic"
          >
            <mat-label>Bursary Fund</mat-label>
            <mat-select
              [(ngModel)]="selectedBursaryType"
              (selectionChange)="onSearchInput({searchTerm: $event.value, searchType: 'bursaryType'})"
            >
              <mat-option *ngFor="let bursaryType of bursaryTypeOptions" [value]="bursaryType">{{
                bursaryType
              }}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field
            class="search-box"
            appearance="outline"
            subscriptSizing="dynamic"
          >
            <mat-label>Filter by year</mat-label>
            <mat-select
              [(ngModel)]="selectedDate"
              (selectionChange)="filterActiveApplicationsByDate($event)"
            >
              <mat-option *ngFor="let date of dateOptions" [value]="date">{{
                date
              }}</mat-option>
            </mat-select>
          </mat-form-field>
        </section>
      </section>
      <section
        class="dashboard"
        fxLayout="row"
        fxLayout.xs="column"
        fxLayoutAlign="start start"
        fxLayoutGap="20px"
      >
      <section *ngIf="applicationsRoute">
        <mat-tab-group
          mat-stretch-tabs="false"
          mat-align-tabs="start"
          animationDuration="0ms"
          [(selectedIndex)]="selectedTabIndex"
          (selectedTabChange)="tabChanged($event)"
        >
          <mat-tab
            label="All ({{ bursaryApplications.length ? bursaryApplications.length : '0' }})"
            [class.active]="isActive"
          >
            <app-consolidated-university-bursary-details
              [details]="getPaginatedData(bursaryApplications)"
              [selectedHeaderTab]="selectedTabIndex"
              [applicationArrayLength]="bursaryApplications.length"
            ></app-consolidated-university-bursary-details>
            <mat-paginator
              *ngIf="bursaryApplications.length > 0"
              [pageSizeOptions]="pageSizeOptions"
              [length]="bursaryApplications.length"
              [pageIndex]="pageIndex"
              [pageSize]="displayPageSize"
              (page)="onPageChange($event)">
            </mat-paginator>
            <section class="error-text-container">
              <p *ngIf="numberOfApplications === 0 && !isLoading" class="error-text">
                No applications found
              </p>
            </section>
          </mat-tab>
          <mat-tab
            label="Applications in progress ({{
              numberApplicationsInProgress ? numberApplicationsInProgress : '0'
            }})"
          >
            <article class="tab-container">
              <ul class="tab-list consolidated-tab-list">
                <li
                  class="tabs"
                  *ngIf="showAllTabs()"
                  [class.active]="selectedTab === 'Draft'"
                  (click)="setSelectedTab('Draft')"
                >
                  Draft <span>({{ numberDraftApplications }})</span>
                </li>
                <li
                  class="tabs"
                  *ngIf="showAllTabs()"
                  [class.active]="selectedTab === 'Email Failed'"
                  (click)="setSelectedTab('Email Failed')"
                >
                  Email failed
                  <span>({{ numberEmailFailedApplications }})</span>
                </li>
              </ul>
            </article>
            <mat-card class="consolidated-details-card details-card">
              <mat-card-content>
                <p class="description" *ngIf="selectedTab">
                  {{ getTabDescription() }}
                </p>
                <article class="tab-content">
                  <section
                    *ngIf="
                      selectedTab === 'Draft' && filteredDraft.length > 0;
                      else noDraft"
                  >
                    <app-consolidated-university-bursary-details
                      [details]="getPaginatedData(filteredDraft)"
                      [currentTab]="selectedTab"
                      [applicationArrayLength]="filteredDraft.length"
                    ></app-consolidated-university-bursary-details>
                    <mat-paginator
                      *ngIf="filteredDraft.length > 0"
                      [pageSizeOptions]="pageSizeOptions"
                      [length]="filteredDraft.length"
                      [pageIndex]="pageIndex"
                      [pageSize]="displayPageSize"
                      (page)="onPageChange($event)">
                    </mat-paginator>
                  </section>
                  <section
                    *ngIf="
                      selectedTab === 'Email Failed' &&
                        filteredEmailFailed.length > 0;
                      else noEmailFailed"
                  >
                    <app-consolidated-university-bursary-details
                      [details]="getPaginatedData(filteredEmailFailed)"
                      [currentTab]="selectedTab"
                      [applicationArrayLength]="filteredEmailFailed.length"
                    ></app-consolidated-university-bursary-details>
                    <mat-paginator
                      *ngIf="filteredEmailFailed.length > 0"
                      [pageSizeOptions]="pageSizeOptions"
                      [length]="filteredEmailFailed.length"
                      [pageIndex]="pageIndex"
                      [pageSize]="displayPageSize"
                      (page)="onPageChange($event)">
                    </mat-paginator>
                  </section>

                  <ng-template #noEmailFailed>
                    <section
                      *ngIf="selectedTab === 'Email Failed'"
                      class="error-text-container"
                    >
                      <p class="error-text">{{ noApplicationsErrorMessage }}</p>
                    </section>
                  </ng-template>
                  <ng-template #noDraft>
                    <section
                      *ngIf="selectedTab === 'Draft'"
                      class="error-text-container"
                    >
                      <p class="error-text">{{ noApplicationsErrorMessage }}</p>
                    </section>
                  </ng-template>
                </article>
              </mat-card-content>
            </mat-card>
            <section class="error-text-container"></section>
          </mat-tab>
          <mat-tab label="In review ({{ numberInReviewApplications ? numberInReviewApplications : '0' }})">
            <article class="tab-container">
              <ul class="tab-list consolidated-tab-list">
                <li
                  class="tabs"
                  [ngClass]="{ 'exec-tabs': !showAllTabs() }"
                  [class.active]="selectedTab === 'Awaiting student response'"
                  (click)="setSelectedTab('Awaiting student response')"
                >
                  Awaiting student response<span>({{ filteredPending.length }})</span>
                </li>
                <li
                  class="tabs"
                  [ngClass]="{ 'exec-tabs': !showAllTabs() }"
                  [class.active]="selectedTab === 'First approval'"
                  (click)="setSelectedTab('First approval')"
                >
                  First approval<span>({{ numberFirstApprovalApplications }})</span>
                </li>
                <li
                  class="tabs"
                  [ngClass]="{ 'exec-tabs': !showAllTabs() }"
                  [class.active]="selectedTab === 'Second approval'"
                  (click)="setSelectedTab('Second approval')"
                >
                  Second approval<span>({{ numberSecondApprovalApplications }})</span>
                </li>
                <li
                  class="tabs"
                  [ngClass]="{ 'exec-tabs': !showAllTabs() }"
                  [class.active]="selectedTab === 'Final approval'"
                  (click)="setSelectedTab('Final approval')"
                >
                  Final approval<span>({{ numberFinalApprovalInProgress }})</span>
                </li>
              </ul>
            </article>
            <mat-card class="consolidated-details-card details-card">
              <mat-card-content>
                <p class="description" *ngIf="selectedTab">
                  {{ getTabDescription() }}
                </p>
                <article class="tab-content">
                  <section
                    *ngIf="
                      selectedTab === 'Awaiting student response' &&
                        filteredPending.length > 0;
                      else noAwaitedStudentResponse"
                  >
                    <app-consolidated-university-bursary-details
                      [details]="getPaginatedData(filteredPending)"
                      [currentTab]="selectedTab"
                      [applicationArrayLength]="filteredPending.length"
                    ></app-consolidated-university-bursary-details>
                    <mat-paginator
                      *ngIf="filteredPending.length > 0"
                      [pageSizeOptions]="pageSizeOptions"
                      [length]="filteredPending.length"
                      [pageIndex]="pageIndex"
                      [pageSize]="displayPageSize"
                      (page)="onPageChange($event)">
                    </mat-paginator>
                  </section>
                  <section
                    *ngIf="
                      selectedTab === 'First approval' &&
                        numberFirstApprovalApplications > 0;
                      else noFirstApprovalReview"
                  >
                    <app-consolidated-university-bursary-details
                      [details]="getPaginatedData(filteredFirstApprovalApplications)"
                      [currentTab]="selectedTab"
                      [applicationArrayLength]="numberFirstApprovalApplications"
                    ></app-consolidated-university-bursary-details>
                    <mat-paginator
                      *ngIf="filteredFirstApprovalApplications.length > 0"
                      [pageSizeOptions]="pageSizeOptions"
                      [length]="filteredFirstApprovalApplications.length"
                      [pageIndex]="pageIndex"
                      [pageSize]="displayPageSize"
                      (page)="onPageChange($event)">
                    </mat-paginator>
                  </section>
                  <section
                    *ngIf="
                      selectedTab === 'Second approval' &&
                        numberSecondApprovalApplications > 0;
                      else noSecondApprovalReview"
                  >
                    <app-consolidated-university-bursary-details
                      [details]="getPaginatedData(filteredSecondApprovalApplications)"
                      [currentTab]="selectedTab"
                      [applicationArrayLength]="numberSecondApprovalApplications"
                    ></app-consolidated-university-bursary-details>
                    <mat-paginator
                      *ngIf="filteredSecondApprovalApplications.length > 0"
                      [pageSizeOptions]="pageSizeOptions"
                      [length]="filteredSecondApprovalApplications.length"
                      [pageIndex]="pageIndex"
                      [pageSize]="displayPageSize"
                      (page)="onPageChange($event)">
                    </mat-paginator>
                  </section>
                  <section
                    *ngIf="
                      selectedTab === 'Final approval' &&
                        numberFinalApprovalInProgress > 0;
                      else noFinalApprovalReview"
                  >
                    <app-consolidated-university-bursary-details
                      [details]="getPaginatedData(filteredFinalApprovalApplications)"
                      [currentTab]="selectedTab"
                      [applicationArrayLength]="numberFinalApprovalInProgress"
                    ></app-consolidated-university-bursary-details>
                    <mat-paginator
                      *ngIf="filteredFinalApprovalApplications.length > 0"
                      [pageSizeOptions]="pageSizeOptions"
                      [length]="filteredFinalApprovalApplications.length"
                      [pageIndex]="pageIndex"
                      [pageSize]="displayPageSize"
                      (page)="onPageChange($event)">
                    </mat-paginator>
                  </section>

                  <ng-template #noAwaitedStudentResponse>
                    <section
                      *ngIf="selectedTab === 'Awaiting student response'"
                      class="error-text-container"
                    >
                      <p class="error-text">{{ noApplicationsErrorMessage }}</p>
                    </section>
                  </ng-template>
                  <ng-template #noFirstApprovalReview>
                    <section
                      *ngIf="selectedTab === 'First approval'"
                      class="error-text-container"
                    >
                      <p class="error-text">{{ noApplicationsErrorMessage }}</p>
                    </section>
                  </ng-template>
                  <ng-template #noSecondApprovalReview>
                    <section
                      *ngIf="selectedTab === 'Second approval'"
                      class="error-text-container"
                    >
                      <p class="error-text">{{ noApplicationsErrorMessage }}</p>
                    </section>
                  </ng-template>
                  <ng-template #noFinalApprovalReview>
                    <section
                      *ngIf="selectedTab === 'Final approval'"
                      class="error-text-container"
                    >
                      <p class="error-text">{{ noApplicationsErrorMessage }}</p>
                    </section>
                  </ng-template>
                </article>
              </mat-card-content>
            </mat-card>
            <section class="error-text-container"></section>
          </mat-tab>

          <mat-tab
            label="Bursary Processing ({{
              numberApplicationsInBursaryProcessing ? numberApplicationsInBursaryProcessing : '0'
            }})"
          >
            <article class="tab-container">
              <ul class="tab-list consolidated-tab-list">
                <li
                  class="tabs"
                  *ngIf="showAllTabs()"
                  [class.active]="selectedTab === 'Contract'"
                  (click)="setSelectedTab('Contract')"
                >
                  Contract<span>({{ numberContractApplications }})</span>
                </li>
                <li
                  class="tabs"
                  [ngClass]="{ 'exec-tabs': !showAllTabs() }"
                  [class.active]="selectedTab === 'Invoice'"
                  (click)="setSelectedTab('Invoice')"
                >
                    Invoice
                  <span>({{ numberInvoiceApplications }})</span>
                </li>
                <li
                  class="tabs"
                  *ngIf="showAllTabs()"
                  [class.active]="selectedTab === 'Payment'"
                  (click)="setSelectedTab('Payment')"
                >
                  Payment <span>({{ numberPaymentApplications }})</span>
                </li>
              </ul>
            </article>
            <mat-card class="consolidated-details-card details-card">
              <mat-card-content>
                <p class="description" *ngIf="selectedTab">
                  {{ getTabDescription() }}
                </p>
                <article class="tab-content">
                  <section
                    *ngIf="
                      selectedTab === 'Contract' && filteredContract.length > 0;
                      else noContract"
                  >
                    <app-consolidated-university-bursary-details
                      [details]="getPaginatedData(filteredContract)"
                      [currentTab]="selectedTab"
                      [applicationArrayLength]="filteredContract.length"
                    ></app-consolidated-university-bursary-details>
                    <mat-paginator
                      *ngIf="filteredContract.length > 0"
                      [pageSizeOptions]="pageSizeOptions"
                      [length]="filteredContract.length"
                      [pageIndex]="pageIndex"
                      [pageSize]="displayPageSize"
                      (page)="onPageChange($event)">
                    </mat-paginator>
                  </section>
                  <section
                    *ngIf="
                      selectedTab === 'Payment' && filteredPayment.length > 0;
                      else noPayment"
                  >
                    <app-consolidated-university-bursary-details
                      [details]="getPaginatedData(filteredPayment)"
                      [currentTab]="selectedTab"
                      [applicationArrayLength]="filteredPayment.length"
                    ></app-consolidated-university-bursary-details>
                    <mat-paginator
                      *ngIf="filteredPayment.length > 0"
                      [pageSizeOptions]="pageSizeOptions"
                      [length]="filteredPayment.length"
                      [pageIndex]="pageIndex"
                      [pageSize]="displayPageSize"
                      (page)="onPageChange($event)">
                    </mat-paginator>
                  </section>
                  <section
                    *ngIf="
                      selectedTab === 'Invoice' &&
                        numberInvoiceApplications > 0;
                      else noInvoice"
                  >
                    <app-consolidated-university-bursary-details
                      [details]="getPaginatedData(filteredInvoice)"
                      [currentTab]="selectedTab"
                      [applicationArrayLength]="filteredInvoice.length"
                    ></app-consolidated-university-bursary-details>
                    <mat-paginator
                      *ngIf="filteredInvoice.length > 0"
                      [pageSizeOptions]="pageSizeOptions"
                      [length]="filteredInvoice.length"
                      [pageIndex]="pageIndex"
                      [pageSize]="displayPageSize"
                      (page)="onPageChange($event)">
                    </mat-paginator>
                  </section>
                  <ng-template #noInvoice>
                    <section
                      *ngIf="selectedTab === 'Invoice'"
                      class="error-text-container"
                    >
                      <p class="error-text">
                        {{ noApplicationsErrorMessage }}
                      </p>
                    </section>
                  </ng-template>
                  <ng-template #noContract>
                    <section
                      *ngIf="selectedTab === 'Contract'"
                      class="error-text-container"
                    >
                      <p class="error-text">{{ noApplicationsErrorMessage }}</p>
                    </section>
                  </ng-template>
                  <ng-template #noPayment>
                    <section
                      *ngIf="selectedTab === 'Payment'"
                      class="error-text-container"
                    >
                      <p class="error-text">{{ noApplicationsErrorMessage }}</p>
                    </section>
                  </ng-template>
                </article>
              </mat-card-content>
            </mat-card>
            <section class="error-text-container"></section>
          </mat-tab>
        </mat-tab-group>
      </section>

      <section *ngIf="activeBursariesRoute">
          <app-consolidated-university-bursary-details
            [details]="getPaginatedData(activeBursaries)"
            [applicationArrayLength]="activeBursaries.length"
          ></app-consolidated-university-bursary-details>
          <mat-paginator
            *ngIf="activeBursaries.length > 0"
            [pageSizeOptions]="pageSizeOptions"
            [length]="activeBursaries.length"
            [pageIndex]="pageIndex"
            [pageSize]="displayPageSize"
            (page)="onPageChange($event)">
          </mat-paginator>
          <section class="error-text-container">
            <p *ngIf="numberOfActiveBursaries === 0 && !isLoading" class="error-text">
              No applications found
            </p>
          </section>
      </section>

      </section>
    </article>

    <app-loader></app-loader>
  </ng-container>
</main>
